// extracted by mini-css-extract-plugin
export var button = "_jv-0";
export var donut = "_jv-1";
export var donutFill = "_jv-3";
export var donutTrack = "_jv-2";